import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

import CookiesBanner from './CookiesBanner.js';

import './style.scss';

var data = require('./data.json');
var searchKeywords = require('../../routes.json');

export default class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            close: false,
            sub: null,
            cookieBanner: true,
            cookieClickCount: 0,
            searchTerm: '',
            searchResults: [],
        };
    }
    componentDidMount() {
        Cookies.get('privacy') ? this.setState({ cookieBanner: false }) : Cookies.set('privacy', true);
        this.setState({ sub: this.props.nav });
    }
    onToggle = () => {
        this.setState({
            close: !this.state.close,
        });
    };
    onToggleSub = key => {
        // Reset state
        if (this.state.sub === key) {
            this.setState({
                sub: '',
            });
        } else {
            this.setState({
                sub: key,
            });
        }
    };
    onClose = () => {
        this.setState({ cookieBanner: false });
    };
    onCookieClickCount = () => {
        this.setState({ cookieClickCount: this.state.cookieClickCount + 1 });
    };
    onSearch = e => {
        if (e.target.value.length > 0) {
            let term = e.target.value.toLowerCase();
            this.setState({ searchTerm: term });
            let searchResults = [];
            searchKeywords.routes.map((route, key) => {
                if (route.keywords.includes(term)) {
                    searchResults.push(route);
                }
                return searchResults;
            });
            this.setState({ searchResults: searchResults });
        } else {
            this.setState({ searchResults: [] });
        }
    };
    render() {
        const { close, sub, searchResults } = this.state;
        const { style, fill, title, url, nav } = this.props;
        const isSelected = testUrl => testUrl === url;
        const extraLinkProps = ({ newTab = false, download = false }) => {
            if (!newTab && !download) return {};
            const result = {};
            if (newTab) {
                result.target = '_blank';
                result.rel = 'noopener noreferrer';
            }
            return result;
        };
        return (
            <nav className={title === 'Home' ? 'home' : null}>
                {this.state.cookieBanner && this.state.cookieClickCount < 2 ? (
                    <CookiesBanner
                        active={this.state.cookieBanner}
                        onClose={this.onClose}
                        onCookieClickCount={this.onCookieClickCount}
                        accept={this.state.cookieClickCount > 0}
                    />
                ) : null}
                <div className={fill ? 'wrapper fill ' + style : 'wrapper'}>
                    {this.state.cookieBanner && this.state.cookieClickCount < 2 ? (
                        <CookiesBanner
                            active={this.state.cookieBanner}
                            onClose={this.onClose}
                            onCookieClickCount={this.onCookieClickCount}
                            accept={this.state.cookieClickCount > 0}
                        />
                    ) : null}
                    <div className="container">
                        <Link to="/" title="JD Group" className="logoLink">
                            <i className="logo"></i>
                        </Link>
                        {fill ? (
                            <div className={style === 'white' ? 'title white' : 'title'}>
                                <h1>{title}</h1>
                                {/*{title === 'Key Facts*' && (
                                    <p className="header-subtitle">*Figures exclude IFRS 16</p>
                                )}*/}
                            </div>
                        ) : fill ? (
                            <div className={style === 'black' ? 'title black' : 'title'}>{title}</div>
                        ) : null}
                        <div onClick={this.onToggle} className={style === 'white' ? style : null}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span>Menu</span>
                        </div>
                    </div>
                </div>
                <div className={close ? 'menu-overlay' : 'menu-overlay hide'} onClick={this.onToggle}></div>
                <div className={close ? 'menu open' : 'menu'}>
                    <div className="close-nav" onClick={this.onToggle}>
                        <span></span>
                        <span></span>
                    </div>
                    <ul className="main">
                        <li className="search">
                            <i className="icon"></i>
                            <input type="text" onChange={this.onSearch.bind(this)} />
                        </li>
                        {searchResults.length === 0 ? null : (
                            <ul className="searchResults">
                                {searchResults.map((item, key) => (
                                    <li key={key}>
                                        <a href={item.url} title={item.text} {...extraLinkProps(item)}>
                                            {item.title}
                                            <p>{item.url}</p>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}
                        {searchResults.length === 0 &&
                            data.items.map((item, key) => (
                                <li key={key} onClick={this.onToggleSub.bind(this, key)}>
                                    {item.url ? (
                                        <a
                                            href={item.url}
                                            title={item.text}
                                            {...extraLinkProps(item)}
                                            className={
                                                nav === 3 && item.url === '/careers'
                                                    ? 'selected'
                                                    : nav === 4 && item.url === '/contact-us'
                                                    ? 'selected'
                                                    : null
                                            }
                                        >
                                            {item.text}
                                        </a>
                                    ) : (
                                        item.text
                                    )}
                                    {item.sub && item.sub.length > 0 && (
                                        <Fragment>
                                            <i className={sub === key ? 'menu-icon close' : 'menu-icon'}></i>
                                            <ul className={sub === key ? 'sub show' : 'sub'}>
                                                {item.sub &&
                                                    item.sub.map((tier2, key) => (
                                                        <li key={key}>
                                                            {tier2.sub ? (
                                                                <Fragment>
                                                                    <a
                                                                        href={tier2.url}
                                                                        title={tier2.text}
                                                                        {...extraLinkProps(tier2)}
                                                                        className={
                                                                            isSelected(tier2.url) ? 'selected' : null
                                                                        }
                                                                    >
                                                                        <span className="thirdTier">{tier2.text}</span>
                                                                    </a>
                                                                    <ul className="thirdTier">
                                                                        {tier2.sub &&
                                                                            tier2.sub.map((tier3, key) => (
                                                                                <li key={key}>
                                                                                    <a
                                                                                        href={tier3.url}
                                                                                        title={tier3.text}
                                                                                        {...extraLinkProps(tier3)}
                                                                                        className={
                                                                                            isSelected(tier3.url)
                                                                                                ? 'selected'
                                                                                                : null
                                                                                        }
                                                                                    >
                                                                                        {tier3.text}
                                                                                    </a>
                                                                                </li>
                                                                            ))}
                                                                    </ul>
                                                                </Fragment>
                                                            ) : (
                                                                <a
                                                                    href={tier2.url}
                                                                    title={tier2.text}
                                                                    {...extraLinkProps(tier2)}
                                                                    className={
                                                                        isSelected(tier2.url) ? 'selected' : null
                                                                    }
                                                                >
                                                                    {tier2.text}
                                                                </a>
                                                            )}
                                                        </li>
                                                    ))}
                                            </ul>
                                        </Fragment>
                                    )}
                                </li>
                            ))}
                    </ul>
                </div>
            </nav>
        );
    }
}
